var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisplayText = function SvgDisplayText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 22.554a2 2 0 0 0 0 4h36a2 2 0 1 0 0-4zM20 33.777a1 1 0 0 1 1-1h28a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1M21 39a1 1 0 1 0 0 2h34a1 1 0 1 0 0-2zM20 46.223a1 1 0 0 1 1-1h28a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1M21 51.446a1 1 0 1 0 0 2h30a1 1 0 0 0 0-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11 9.867a1 1 0 0 0-1 1v58a1 1 0 0 0 1 1h58a1 1 0 0 0 1-1v-58a1 1 0 0 0-1-1zm1 58v-56h56v56z",
    clipRule: "evenodd"
  })));
};
export default SvgDisplayText;